import { faClipboardList, faHome } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import {
  useStudyPlanAcademicYearOptions,
  useStudyPlanSemesterOptions,
} from '../../hooks/options/useOptions'
import useFetch from '../../utils/useFetch'
import FormField from './FormField'
import warning from '../../assets/images/warning.png'

const AcademicResultCreate = (props) => {
  const { response: responseData, loading: educationLoading } = useFetch(
    '/student/education/current'
  )

  const auth = localStorage.getItem('user')
  const userData = JSON.parse(auth)
  
  const hasContract = userData?.has_contract
  const hasEducation = userData?.has_education

  if (!hasContract || !hasEducation) {
    return (
     <div className="mt-4">
        <section className="bg-light">
          <div className="container">
            <div className="card border-0 mb-3 d-flex py-4">
            
              <img src={warning} className="img-alert-warning"/>
              <h1 className="text-center text-primary">สัญญาของคุณยังไม่สมบูรณ์</h1>
            </div>
          </div>
        </section>
      </div>
    )
  }

  return (
    <>
      <nav aria-label="breadcrumb">
        <ol id="w9" className="breadcrumb container py-2 mb-0 px-3">
          <li className="breadcrumb-item">
            <Link to="/">
              <FontAwesomeIcon icon={faHome} />
            </Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/academic-result"> ผลการศึกษา </Link>
          </li>
          <li className="breadcrumb-item active font-sarabun" aria-current="page">
            ยื่นผลการศึกษา
          </li>
        </ol>
      </nav>
      <div className="academic-result-create">
        <section className="bg-light">
          <div className="container">
            <div className="card border-0 mb-3">
              <div className="card-header">
                <div className="d-md-flex pt-4 bg-white border-0 ps-0 w-100  my-0 mx-auto">
                  <div>
                    <h5 className="card-title d-flex align-items-center me-auto texr-start ps-0">
                      <div className="bg-icon">
                        <FontAwesomeIcon icon={faClipboardList} className="" />
                      </div>
                      <span>ยื่นผลการศึกษา </span>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="card-body">
                {!educationLoading ? (
                  <>
                    <FormField data={responseData} />
                  </>
                ) : (
                  <>
                    <Row>
                      <Col md="6" className="mb-3">
                        <Skeleton height={20} />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Skeleton height={20} />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Skeleton height={20} />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Skeleton height={20} />
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12" className="mb-3">
                        <Skeleton height={20} />
                      </Col>
                      <Col md="12" className="mb-3">
                        <Skeleton height={20} />
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default AcademicResultCreate
